import { render } from "./TelemetryItem.vue?vue&type=template&id=f118d17c"
import script from "./TelemetryItem.vue?vue&type=script&lang=js"
export * from "./TelemetryItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__